import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
import { ValidMachine } from '../shared/viewmodels/ISearchService';

@Injectable()
export class LandingPageService {
  myAppUrl: string = "";

  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getValidMachine(machineId: string) {
    const params = new HttpParams().set('MachineId', machineId);
    return this._http.get<ValidMachine>(this.myAppUrl + 'api/CoreData/GetValidMachine?MachineID=' + machineId);
  }
}
